import { Box, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import React from 'react';

interface ErrorProps {
  message: string;
  caption?: string;
  append?: React.ReactNode;
  autoClose?: number | false | undefined;
}
export const useErrorToast = () => {
  const toastId = 'error-toast';
  const close = () => toast.dismiss(toastId);

  const open = (props: ErrorProps) => {
    const { message, caption, append, autoClose = 5000 } = props;
    console.log('error message', message, 'caption', caption);

    const Msg = () => {
      return (
        <Box>
          <Typography variant="body2">{message}</Typography>
          {caption && <Typography variant="caption">{caption}</Typography>}
          {append && append}
        </Box>
      );
    };

    toast.error(<Msg />, {
      toastId,
      autoClose,
    });
  };

  return {
    open,
    close,
  };
};
